<template lang="pug">
  transition(name="asd__fade")
    .asd__wrapper(
      v-show="showDatepicker"
      :id="wrapperId"
      :class="wrapperClasses"
      :style="showFullscreen ? undefined : wrapperStyles"
      v-click-outside="handleClickOutside"
    )
      button.asd__close-icon(
        type="button"
        @click="closeDatepickerCancel"
      )
      .asd__mobile-header.asd__mobile-only( v-if="showFullscreen" )
        .asd__mobile-close( @click="closeDatepicker" )
          .asd__mobile-close-icon X
        h3 {{ mobileHeader }}
      .asd__datepicker-header
        .asd__time-header
          .asd__time-list
            button.asd__time-button(
              type="button"
              @click="setFixedDate('week')"
              :class="{ 'asd__time-button_current' : currentFixedTime === 'week' }"
            ) Неделя
            button.asd__time-button(
              type="button"
              @click="setFixedDate('month')"
              :class="{ 'asd__time-button_current' : currentFixedTime === 'month' }"
            ) Месяц
            button.asd__time-button(
              type="button"
              @click="setFixedDate('quarter')"
              :class="{ 'asd__time-button_current' : currentFixedTime === 'quarter' }"
            ) Квартал
            button.asd__time-button(
              type="button"
              @click="setFixedDate('year')"
              :class="{ 'asd__time-button_current' : currentFixedTime === 'year' }"
            ) Год
          .asd__time-current-inputs
            .asd__time-input-wrapper
              input.asd__time-input(
                type="text" name="time"
                id="start-time"
                autocomplete="off"
                v-model="dateFrom"
                @keyup.enter="setDateFromText(dateFrom)"
              )
            span  -
            .asd__time-input-wrapper
              input.asd__time-input(
                type="text"
                name="time"
                id="end-time"
                autocomplete="off"
                v-model="dateTo"
                @keyup.enter="setDateFromText(dateTo)"
              )
        .asd__timebar
          .asd__timebar-scroll(
            ref="timebarScroll"
            :style="scrollStyles"
            @mousedown="toggleScroll"
          )
          .asd__timebar-monthes( ref="timebarWrapper" )
            .asd__timebar-progress( :style="timebarStyles" )
              .asd__timebar-progress-current(
                ref="currentProgressBar"
                :style="currentTimebarStyles"
              )
              span(
                v-for="(year, index) in currentYears"
                :key="index"
                :data-year="year.item"
                :style="{left: year.posLeft}"
                @:click="selectDate(year.fullDate, true, year.posLeft)"
              ) {{ year.item }}
        .asd__change-month-button.asd__change-month-button--previous
          button(
            type="button"
            @click="previousMonth"
          )
            svg(
              width="13"
              height="12"
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            )
              path(
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 6L6 0V4H13V8H6V12L0 6Z"
                fill="#24A2B4"
              )
        .asd__change-month-button.asd__change-month-button--next
          button(
            type="button"
            @click="nextMonth"
          )
            svg(
              width="13"
              height="12"
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            )
              path(
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13 6L7 12V8H0V4H7V0L13 6Z"
                fill="#24A2B4"
              )
      .asd__days-legend-wrapper
        .asd__days-legend(
          v-for="(month, index) in showMonths"
          :key="month"
          :style="[monthWidthStyles, {left: (width * index) + 'px'}]"
        )
          .asd__day-title(
            v-for="day in daysShort"
            :key="day"
          ) {{ day }}
      .asd__inner-wrapper(
        :style="innerStyles"
        @touchstart="touchStart($event)"
        @touchmove="touchMove($event)"
        @touchend="touchEnd($event)"
      )
        .asd__month(
          v-for="(month, monthIndex) in months"
          :key="month.firstDateOfMonth"
          :class="{hidden: monthIndex === 0 || monthIndex > showMonths}"
          :style="monthWidthStyles"
        )
          .asd__month-name {{ month.monthName }} {{ month.year }}
          table.asd__month-table(role="presentation")
            tbody
            tr.asd__week(
              v-for="(week, index) in month.weeks"
              :key="index"
            )
              td.asd__day(
                v-for="({fullDate, dayNumber}, index) in week"
                :key="index + '_' + dayNumber"
                :data-date="fullDate"
                :class="dayClass(dayNumber, fullDate)"
                :style="getDayStyles(fullDate)"
                @mouseover="() => { setHoverDate(fullDate) }"
              )
                button.asd__day-button(
                  type="button"
                  v-if="dayNumber"
                  :date="fullDate"
                  :disabled="isDisabled(fullDate)"
                  :class="{ 'asd__day-button_weekend' : isWeekendDay(fullDate, dayNumber) }"
                  @click="selectDate(fullDate)"
                ) {{ dayNumber }}
      .asd__action-buttons( v-if="mode !== 'single' && showActionButtons" )
        button(
          type="button"
          @click="apply"
        ) {{ texts.apply }}
</template>

<script>
/* eslint-disable */
    import format from 'date-fns/format'
    import subMonths from 'date-fns/sub_months'
    import addMonths from 'date-fns/add_months'
    import getDaysInMonth from 'date-fns/get_days_in_month'
    import isBefore from 'date-fns/is_before'
    import isEqual from 'date-fns/is_equal'
    import isAfter from 'date-fns/is_after'
    import isValid from 'date-fns/is_valid'
    import {
        debounce,
        copyObject,
        findAncestor,
        randomString,
        isWeekend,
        reverseDate,
        inRange,
        isValidDate
    } from '../helpers/datepicker'
    export default {
        name: 'RslDatePicker',
        props: {
            triggerElementId: { type: String },
            dateOne: {
                type: [String, Date],
                default: format(new Date()),
                validator (val) {
                    if (!val) return true
                    return isValidDate(val)
                }
            },
            dateTwo: {
                type: [String, Date],
                default: '',
                validator (val) {
                    if (!val) return true
                    return isValidDate(val)
                }
            },
            minDate: { type: [String, Date] },
            endDate: { type: [String, Date] },
            mode: { type: String, default: 'range' },
            offsetY: { type: Number, default: 0 },
            offsetX: { type: Number, default: 0 },
            monthsToShow: { type: Number, default: 3 },
            startOpen: { type: Boolean },
            fullscreenMobile: { type: Boolean, default: true },
            inline: { type: Boolean },
            mobileHeader: { type: String, default: 'Select date' },
            disabledDates: { type: Array, default: () => [] },
            showActionButtons: { type: Boolean, default: true },
            isTest: {
                type: Boolean,
                default: () => process.env.NODE_ENV === 'test'
            },
            dateFormat: {
                type: String,
                required: false,
                default: `DD.MM.YYYY`
            },
            inBorderMode: {
                type: Boolean,
                require: false,
                default: true
            },
            endYearForRange: {
                type: Date,
                required: false,
                default () {
                    return new Date()
                }
            },
            rangeBarMode: {
                type: Boolean,
                required: false,
                default: true
            },
            bookingMode: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data () {
            return {
                dateTo: '',
                dateFrom: '',
                wrapperId: 'airbnb-style-datepicker-wrapper-' + randomString(5),
                showDatepicker: false,
                showMonths: 3,
                colors: {
                    selected: '#e2f5f7',
                    inRange: '#e2f5f7',
                    selectedText: '#fff',
                    text: '#565a5c',
                    disabled: '#fff'
                },
                sundayFirst: false,
                monthNames: [
                    'Январь',
                    'Февраль',
                    'Март',
                    'Апрель',
                    'Май',
                    'Июнь',
                    'Июль',
                    'Август',
                    'Сентябрь',
                    'Октябрь',
                    'Ноябрь',
                    'Декабрь'
                ],
                days: [
                    'Понедельник',
                    'Вторник',
                    'Среда',
                    'Четверг',
                    'Пятница',
                    'Суббота',
                    'Воскресенье'
                ],
                daysShort: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
                texts: { apply: 'Применить', cancel: 'Отменить' },
                startingDate: '',
                months: [],
                width: 250,
                selectedDate1: '',
                selectedDate2: '',
                isSelectingDate1: true,
                hoverDate: '',
                alignRight: false,
                triggerPosition: {},
                triggerWrapperPosition: {},
                viewportWidth: window.innerWidth + 'px',
                isMobile: window.innerWidth < 768,
                isTablet: window.innerWidth >= 768 && window.innerWidth <= 1024,
                triggerElement: undefined,
                currentPointScroll: 0,
                currentScrollPos: 0,
                currentTimebarWidth: 0,
                currentTimebarLeftPos: 0,
                currentTimebarStart: 0,
                currentTimebarEnd: 0,
                timebarPosLeft: 0,
                timebarAllPosLeft: 0,
                isFirstLoaded: true,
                parentToggleScrollWidth: 0,
                currentFixedTime: ``
            }
        },
        computed: {
            currentProgress () {
                return this.currentTimebarEnd - this.currentTimebarStart
            },
            currentYears () {
                const currentDate = this.endYearForRange
                let currentYear = currentDate.getFullYear() + 1
                const currentYears = []
                for (let i = 15; i >= 0; i--) {
                    currentYear--
                    currentYears.push({
                        item: currentYear + 1,
                        fullDate: `${currentYear + 1}.01.01`,
                        posLeft: `${120 * i}px`,
                        leftCoords: 12 * i
                    })
                }
                return currentYears.reverse()
            },
            currentTimebarStyles () {
                return {
                    width: `${this.currentTimebarWidth}px`,
                    left: `${this.currentTimebarLeftPos}px`
                }
            },
            timebarStyles: {
                get () {
                    let timebarWidth = 0
                    for (let i = 0; i < this.currentYears.length; i++) {
                        timebarWidth += 12
                    }
                    return {
                        width: `${timebarWidth * 10}px`,
                        left: `${this.timebarAllPosLeft}px`
                    }
                }
            },
            scrollStyles () {
                return {
                    left: `${this.currentScrollPos}px`
                }
            },
            wrapperClasses () {
                return {
                    'asd__wrapper--datepicker-open': this.showDatepicker,
                    'asd__wrapper--full-screen': this.showFullscreen,
                    'asd__wrapper--inline': this.inline
                }
            },
            wrapperStyles () {
                return {
                    position: this.inline ? 'static' : 'absolute',
                    top: this.inline
                        ? '0'
                        : this.triggerPosition.height + this.offsetY + 'px',
                    left: !this.alignRight
                        ? this.triggerPosition.left -
                            this.triggerWrapperPosition.left +
                            this.offsetX + 'px'
                        : '',
                    right: this.alignRight
                        ? this.triggerWrapperPosition.right -
                            this.triggerPosition.right +
                            this.offsetX + 'px'
                        : '',
                    width: this.width * this.showMonths + 'px',
                    zIndex: this.inline ? '0' : '100'
                }
            },
            innerStyles () {
                return {
                    'margin-left': this.showFullscreen
                        ? '-' + this.viewportWidth
                        : `-${this.width}px`
                }
            },
            monthWidthStyles () {
                return {
                    width: this.showFullscreen ? this.viewportWidth : this.width + 'px'
                }
            },
            showFullscreen () {
                return this.isMobile && this.fullscreenMobile
            },
            datesSelected () {
                return !!(
                    (
                    this.selectedDate1 && this.selectedDate1 !== ''
                    ) || (this.selectedDate2 && this.selectedDate2 !== '')
                )
            },
            allDatesSelected () {
                return !!(
                    this.selectedDate1 &&
                    this.selectedDate1 !== '' &&
                    this.selectedDate2 &&
                    this.selectedDate2 !== ''
                )
            },
            hasMinDate () {
                return !!(this.minDate && this.minDate !== '')
            },
            isRangeMode () {
                return this.mode === 'range'
            },
            isSingleMode () {
                return this.mode === 'single'
            },
            datepickerWidth () {
                return this.width * this.showMonths
            },
            datePropsCompound () {
                return this.dateOne + this.dateTwo
            },
            isDateTwoBeforeDateOne () {
                if (!this.dateTwo) {
                    return false
                }
                return isBefore(this.dateTwo, this.dateOne)
            }
        },
        watch: {
            currentPointScroll (val) {
                const PARENT_WIDTH = 192 // длинна оси лет в шагах
                const TOGGLE_WIDTH = 15 // ширина ползунка на оси лет в шагах
                let currentWay = this.currentYears.length * 12 // общее количество шагов
                if (val > (PARENT_WIDTH - TOGGLE_WIDTH)) { // колличество шагов если больше максимума
                    this.currentPointScroll = PARENT_WIDTH - TOGGLE_WIDTH
                }
                if (val <= 0) { // колличество шагов если первый месяц первого года
                    this.currentPointScroll = 0
                }
                this.timebarAllPosLeft = -Math.abs(val * 6.5) // 192 -> 1248 положение оси лет в пикселях
                this.currentScrollPos = Math.floor(val * 3.5) // 192 -> 670 положение ползунка в пикселях
                for (let i = this.currentYears.length - 1; i > 0; --i) {
                    currentWay -= 12
                    let total = currentWay - val
                    let month = 12 - total
                    if (inRange(val, (this.currentYears[i - 1].leftCoords), (this.currentYears[i].leftCoords))) {
                        if (val === 0) {
                            this.startingDate = `${this.currentYears[i - 1].item - 1}-12-1`
                            this.generateMonths()
                            break
                        }
                        this.startingDate = `${this.currentYears[i - 1].item}-${month}-1`
                        this.generateMonths()
                    }
                }
            },
            dateFrom (newVal) {
                if (!isValidDate(newVal)) {
                    this.$emit('date-one-selected', '')
                    this.$emit('inCorrectDate', 'dateFrom')
                }
                if (newVal) {
                    this.setCurrentTimebarWidth({
                        from: newVal,
                        to: this.dateTo
                    })
                }
            },
            dateTo (newVal) {
                if (!isValidDate(newVal)) {
                    this.$emit('date-two-selected', '')
                    this.$emit('inCorrectDate', 'dateTo')
                }
                if (newVal) {
                    this.setCurrentTimebarWidth({
                        from: this.dateFrom,
                        to: newVal
                    })
                } else {
                    this.currentTimebarWidth = 0
                }
            },
            selectedDate1 (newValue, oldValue) {
                let newDate = !newValue ? '' : format(newValue, this.dateFormat)
                this.$emit('date-one-selected', newDate)
                this.dateFrom = reverseDate(newDate)
            },
            selectedDate2 (newValue, oldValue) {
                let newDate = !newValue || newValue === '' ? '' : format(newValue, this.dateFormat)
                this.$emit('date-two-selected', newDate)
                this.dateTo = reverseDate(newDate)
            },
            mode (newValue, oldValue) {
                this.setStartDates()
            },
            datePropsCompound (newValue) {
                if (this.dateOne !== this.selectedDate1) {
                    this.startingDate = this.dateOne
                    this.setStartDates()
                    this.generateMonths()
                }
                if (this.bookingMode) {
                    if (this.isDateTwoBeforeDateOne) {
                        this.selectedDate2 = ''
                        this.$emit('date-two-selected', '')
                    }
                }
            }
        },
        created () {
            this.setupDatepicker()
            if (this.sundayFirst) {
                this.setSundayToFirstDayInWeek()
            }
            this._handleWindowResizeEvent = debounce(() => {
                this.positionDatepicker()
                this.setStartDates()
            }, 200)
            this._handleWindowClickEvent = event => {
                if (event.target.id === this.triggerElementId) {
                    event.stopPropagation()
                    event.preventDefault()
                    this.toggleDatepicker()
                }
            }
            window.addEventListener('resize', this._handleWindowResizeEvent)
            window.addEventListener('click', this._handleWindowClickEvent)
        },
        mounted () {
            this.triggerElement = this.isTest
                ? document.createElement('input')
                : document.getElementById(this.triggerElementId)
            this.setStartDates()
            this.generateMonths()
            if (this.startOpen || this.inline) {
                this.openDatepicker()
            }
            this.triggerElement.addEventListener('keyup', this.handleTriggerInput)
        },
        beforeDestroy () {
            this.isFirstLoaded = true
        },
        destroyed () {
            window.removeEventListener('resize', this._handleWindowResizeEvent)
            window.removeEventListener('click', this._handleWindowClickEvent)
            this.triggerElement.removeEventListener('keyup', this.handleTriggerInput)
        },
        methods: {
            setCurrentTimebarWidth (date) {
                const wrapper = document.querySelector(`#${this.wrapperId}`)
                const years = Array.from(wrapper.querySelectorAll(`.asd__timebar-progress > span`))
                function getInt (val) {
                    return parseInt(val.style.left)
                }
                let year = this.getMonth(reverseDate(date.from)).year - (this.endYearForRange.getFullYear() - this.currentYears.length + 2) // определяем номер года
                let month = this.getMonth(reverseDate(date.from)).monthNumber - 1 // определяем номер месяца
                let nextPointScroll = year * 12 + month * 1 // определяем следующую позицию для отображения
                let isNextYear = Math.abs(this.currentPointScroll - nextPointScroll) > this.monthsToShow // прелистываем если позиция дальше от текущей больше чем на год
                if (date.to) {
                    const dateFrom = years.find(it => it.textContent.trim() === date.from.split('.')[2])
                    const dateTo = years.find(it => it.textContent.trim() === date.to.split('.')[2])
                    if (dateFrom && dateTo) {
                        if (getInt(dateFrom) > getInt(dateTo)) {
                            this.currentTimebarWidth = 0
                            return
                        }
                    }
                    if (dateFrom) {
                        this.currentTimebarStart = getInt(dateFrom)
                        this.currentTimebarLeftPos = getInt(dateFrom)
                        if (isNextYear) this.currentPointScroll = nextPointScroll
                    }
                    if (dateTo) {
                        this.currentTimebarEnd = getInt(dateTo)
                    }
                    this.currentTimebarWidth = this.currentProgress
                } else {
                    const dateFrom = years.find(it => it.textContent.trim() === date.from.split('.')[2])
                    this.currentTimebarStart = getInt(dateFrom)
                    this.currentTimebarLeftPos = getInt(dateFrom)
                    if (isNextYear) this.currentPointScroll = nextPointScroll
                }
            },
            touchStart (e) {
            },
            touchMove (e) {
            },
            touchEnd (e) {
            },
            setFixedDate (type) {
                this.currentFixedTime = type
                let currentDate = new Date()
                let startDate
                switch (type) {
                case 'week':
                    startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 7)
                    break
                case 'month':
                    startDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate())
                    break
                case 'quarter':
                    startDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 4, currentDate.getDate())
                    break
                case 'year':
                    startDate = new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate())
                    break
                }
                this.selectedDate1 = startDate
                this.selectedDate2 = currentDate
                this.startingDate = startDate
                this.generateMonths()
            },
            toggleScroll (e) {
                e.preventDefault()
                let currentPointX = e.clientX
                const onMouseMove = moveEvt => {
                    moveEvt.preventDefault()
                    let pressedX = currentPointX - moveEvt.clientX
                    currentPointX = moveEvt.clientX
                    let passedX = e.target.offsetLeft - pressedX
                    this.timebarPosLeft = Math.abs(passedX * 6.5) // 1248 -> 192; 1248 - длинна оси лет, 192 - колличество шагов
                    this.currentPointScroll = Math.floor(passedX / 3.5) // 670 -> 192; 670 - ширина области ползунка лет, 192 - колличество шагов
                }
                let onMouseUp = upEvt => {
                    upEvt.preventDefault()
                    document.removeEventListener('mousemove', onMouseMove)
                    document.removeEventListener('mouseup', onMouseUp)
                }
                document.addEventListener('mousemove', onMouseMove)
                document.addEventListener('mouseup', onMouseUp)
            },
            isWeekendDay (date, day) {
                let weekends = isWeekend(date)
                return weekends.sat.some(elem => elem === day) || weekends.sun.some(elem => elem === day)
            },
            dayClass(dayNumber, fullDate) {
                return {
                    'asd__day--empty': dayNumber === 0,
                    'asd__day--enabled': dayNumber !== 0,
                    'asd__day--disabled': this.isInRangeisDisabled(fullDate),
                    'asd__day--selected': this.selectedDate1 === fullDate || this.selectedDate2 === fullDate,
                    'asd__day--in-range': this.isInRange(fullDate)
                }
            },
            getDayStyles (date) {
                const isSelected = this.isSelected(date)
                const isInRange = this.isInRange(date)
                const isDisabled = this.isDisabled(date)
                let styles = {
                    width: (this.width - 30) / 7 + 'px',
                    background: isSelected
                        ? this.colors.selected
                        : isInRange ? this.colors.inRange : '',
                    color: isSelected
                        ? this.colors.selectedText
                        : isInRange ? this.colors.selectedText : this.colors.text
                }
                if (isDisabled) {
                    styles.background = this.colors.disabled
                }
                return styles
            },
            handleClickOutside (event) {
                if (
                    event.target.id === this.triggerElementId ||
                    !this.showDatepicker ||
                    this.inline
                ) {
                    return
                }
                this.closeDatepicker()
            },
            handleTriggerInput (event) {
                const keys = {
                    arrowDown: 40,
                    arrowUp: 38,
                    arrowRight: 39,
                    arrowLeft: 37
                }
                if (
                    event.keyCode === keys.arrowDown &&
                    !event.shiftKey &&
                    !this.showDatepicker
                ) {
                    this.openDatepicker()
                } else if (
                    event.keyCode === keys.arrowUp &&
                    !event.shiftKey &&
                    this.showDatepicker
                ) {
                    this.closeDatepicker()
                } else if (
                    event.keyCode === keys.arrowRight &&
                    !event.shiftKey &&
                    this.showDatepicker
                ) {
                    this.nextMonth()
                } else if (
                    event.keyCode === keys.arrowLeft &&
                    !event.shiftKey &&
                    this.showDatepicker
                ) {
                    this.previousMonth()
                } else {
                    if (this.mode === 'single') {
                        this.setDateFromText(event.target.value)
                    }
                }
            },
            setDateFromText (value) {
                if (value.length < 10) {
                    return
                }
                // make sure format is either 'YYYY-MM-DD' or 'DD.MM.YYYY'
                const isFormatYearFirst = value.match(
                    /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/
                )
                const isFormatDayFirst = value.match(
                    /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])[.](0[1-9]|1[0-2])[.](\d{4})$/
                )
                if (!isFormatYearFirst && !isFormatDayFirst) {
                    return
                }
                const valueAsDateObject = new Date(value)
                if (!isValid(valueAsDateObject)) {
                    return
                }
                const formattedDate = format(valueAsDateObject, this.dateFormat)
                if (
                    this.isDateDisabled(formattedDate) ||
                    this.isBeforeMinDate(formattedDate) ||
                    this.isAfterEndDate(formattedDate)
                ) {
                    return
                }
                this.startingDate = subMonths(formattedDate, 1)
                this.generateMonths()
                this.selectDate(formattedDate)
            },
            generateMonths () {
                this.months = []
                for (let i = 0; i < this.showMonths + 2; i++) {
                    this.months.push(this.getMonth(this.startingDate))
                    this.startingDate = this.addMonths(this.startingDate)
                }
            },
            setupDatepicker () {
                if (this.$options.sundayFirst) {
                    this.sundayFirst = copyObject(this.$options.sundayFirst)
                }
                if (this.$options.colors) {
                    const colors = copyObject(this.$options.colors)
                    this.colors.selected = colors.selected || this.colors.selected
                    this.colors.inRange = colors.inRange || this.colors.inRange
                    this.colors.selectedText = colors.selectedText || this.colors.selectedText
                    this.colors.text = colors.text || this.colors.text
                    this.colors.inRangeBorder = colors.inRangeBorder || this.colors.inRangeBorder
                    this.colors.disabled = colors.disabled || this.colors.disabled
                }
                if (this.$options.monthNames && this.$options.monthNames.length === 12) {
                    this.monthNames = copyObject(this.$options.monthNames)
                }
                if (this.$options.days && this.$options.days.length === 7) {
                    this.days = copyObject(this.$options.days)
                }
                if (this.$options.daysShort && this.$options.daysShort.length === 7) {
                    this.daysShort = copyObject(this.$options.daysShort)
                }
                if (this.$options.texts) {
                    const texts = copyObject(this.$options.texts)
                    this.texts.apply = texts.apply || this.texts.apply
                    this.texts.cancel = texts.cancel || this.texts.cancel
                }
            },
            setStartDates (date) {
                let startDate
                if (date) {
                    startDate = date
                } else {
                    startDate = this.dateOne || new Date()
                }
                if (this.hasMinDate && isBefore(startDate, this.minDate)) {
                    startDate = this.minDate
                }
                this.startingDate = this.subtractMonths(startDate)
                this.selectedDate1 = this.dateOne
                this.selectedDate2 = this.dateTwo
            },
            setSundayToFirstDayInWeek () {
                const lastDay = this.days.pop()
                this.days.unshift(lastDay)
                const lastDayShort = this.daysShort.pop()
                this.daysShort.unshift(lastDayShort)
            },
            getMonth (date) {
                const firstDateOfMonth = format(date, 'YYYY-MM-01')
                const year = format(date, 'YYYY')
                const monthNumber = parseInt(format(date, 'M'))
                const monthName = this.monthNames[monthNumber - 1]
                return {
                    year,
                    firstDateOfMonth,
                    monthName,
                    monthNumber,
                    weeks: this.getWeeks(firstDateOfMonth)
                }
            },
            getWeeks (date) {
                const weekDayNotInMonth = { dayNumber: 0 }
                const daysInMonth = getDaysInMonth(date)
                const year = format(date, 'YYYY')
                const month = format(date, 'MM')
                let firstDayInWeek = parseInt(format(date, this.sundayFirst ? 'd' : 'E'))
                if (this.sundayFirst) {
                    firstDayInWeek++
                }
                let weeks = []
                let week = []
                // add empty days to get first day in correct position
                for (let s = 1; s < firstDayInWeek; s++) {
                    week.push(weekDayNotInMonth)
                }
                for (let d = 0; d < daysInMonth; d++) {
                    let isLastDayInMonth = d >= daysInMonth - 1
                    let dayNumber = d + 1
                    let dayNumberFull = dayNumber < 10 ? '0' + dayNumber : dayNumber
                    week.push({
                        dayNumber,
                        dayNumberFull: dayNumberFull,
                        fullDate: year + '-' + month + '-' + dayNumberFull
                    })
                    if (week.length === 7) {
                        weeks.push(week)
                        week = []
                    } else if (isLastDayInMonth) {
                        for (let i = 0; i < 7 - week.length; i++) {
                            week.push(weekDayNotInMonth)
                        }
                        weeks.push(week)
                        week = []
                    }
                }
                return weeks
            },
            selectDate (date, isFixed, posLeft) {
                this.currentFixedTime = ``
                const reversedDate = reverseDate(date)
                if (isFixed) {
                    this.startingDate = reversedDate
                    this.generateMonths()
                }
                if (
                    this.isBeforeMinDate(reversedDate) ||
                    this.isAfterEndDate(reversedDate) ||
                    this.isDateDisabled(reversedDate)
                ) {
                    return
                }
                if (this.mode === 'single') {
                    this.selectedDate1 = reversedDate
                    this.closeDatepicker()
                    return
                }
                if (this.isSelectingDate1 || isBefore(reversedDate, this.selectedDate1)) {
                    this.selectedDate1 = reversedDate
                    this.isSelectingDate1 = false
                    if (!this.bookingMode) {
                        this.selectedDate2 = ``
                    }
                    if (isBefore(this.selectedDate2, reversedDate)) {
                        this.selectedDate2 = ``
                    }
                } else {
                    this.selectedDate2 = reversedDate
                    this.isSelectingDate1 = true
                    if (isAfter(this.selectedDate1, reversedDate)) {
                        this.selectedDate1 = ``
                    }
                }
            },
            setHoverDate (date) {
                if (this.bookingMode) {
                    this.hoverDate = date
                }
            },
            isSelected (date) {
                if (!date) {
                    return
                }
                return this.selectedDate1 === date || this.selectedDate2 === date
            },
            isInRange (date) {
                if (this.inBorderMode || !this.allDatesSelected) {
                    return isEqual(
                        date, this.selectedDate1) || (
                            (
                        isAfter(date, this.selectedDate1) &&
                        isBefore(date, this.selectedDate2)
                        ) || (
                        isAfter(date, this.selectedDate1) &&
                        isBefore(date, this.hoverDate) &&
                        !this.allDatesSelected
                        )
                        ) || isEqual(date, this.selectedDate2)
                }
                if (!this.allDatesSelected || this.isSingleMode) {
                    return false
                }
                return (
                    (
                    isAfter(date, this.selectedDate1) &&
                    isBefore(date, this.selectedDate2)
                    ) || (
                    isAfter(date, this.selectedDate1) &&
                    isBefore(date, this.hoverDate) && !this.allDatesSelected
                    )
                )
            },
            isBeforeMinDate (date) {
                if (!this.minDate) {
                    return false
                }
                return isBefore(date, this.minDate)
            },
            isAfterEndDate (date) {
                if (!this.endDate) {
                    return false
                }
                return isAfter(date, this.endDate)
            },
            isDateDisabled (date) {
                return this.disabledDates.indexOf(date) > -1
            },
            isDisabled (date) {
                return (
                    this.isDateDisabled(date) ||
                    this.isBeforeMinDate(date) ||
                    this.isAfterEndDate(date)
                )
            },
            previousMonth () {
                this.currentPointScroll -= 1
                this.startingDate = this.subtractMonths(this.months[0].firstDateOfMonth)
                this.months.unshift(this.getMonth(this.startingDate))
                this.months.splice(this.months.length - 1, 1)
            },
            nextMonth () {
                this.currentPointScroll += 1
                this.startingDate = this.addMonths(
                    this.months[this.months.length - 1].firstDateOfMonth
                )
                this.months.push(this.getMonth(this.startingDate))
                this.months.splice(0, 1)
            },
            subtractMonths (date) {
                return format(subMonths(date, 1), this.dateFormat)
            },
            addMonths (date) {
                return format(addMonths(date, 1), this.dateFormat)
            },
            toggleDatepicker () {
                if (this.showDatepicker) {
                    this.closeDatepicker()
                } else {
                    this.openDatepicker()
                }
            },
            openDatepicker () {
                this.positionDatepicker()
                this.setStartDates()
                this.triggerElement.classList.add('datepicker-open')
                this.showDatepicker = true
                this.initialDate1 = this.dateOne
                this.initialDate2 = this.dateTwo
            },
            closeDatepickerCancel () {
                if (this.showDatepicker) {
                    this.selectedDate1 = this.initialDate1
                    this.selectedDate2 = this.initialDate2
                    this.closeDatepicker()
                }
            },
            closeDatepicker () {
                if (this.inline) {
                    return
                }
                this.showDatepicker = false
                this.triggerElement.classList.remove('datepicker-open')
                this.$emit('closed')
            },
            apply () {
                if (this.dateTo) {
                    this.$emit('date-one-selected', reverseDate(this.dateFrom))
                }
                if (this.dateFrom) {
                    this.$emit('date-two-selected', reverseDate(this.dateTo))
                }
                this.$emit('apply')
                this.closeDatepicker()
            },
            positionDatepicker () {
                const triggerWrapperElement = findAncestor(
                    this.triggerElement,
                    '.datepicker-trigger'
                )
                this.triggerPosition = this.triggerElement.getBoundingClientRect()
                if (triggerWrapperElement) {
                    this.triggerWrapperPosition = triggerWrapperElement.getBoundingClientRect()
                } else {
                    this.triggerWrapperPosition = { left: 0, right: 0 }
                }
                const viewportWidth = document.documentElement.clientWidth || window.innerWidth
                this.viewportWidth = viewportWidth + 'px'
                this.isMobile = viewportWidth < 768
                this.isTablet = viewportWidth >= 768 && viewportWidth <= 1024
                this.showMonths = this.isMobile
                    ? 1
                    : this.isTablet && this.monthsToShow > 2 ? 2 : this.monthsToShow
                this.$nextTick(function () {
                    const datepickerWrapper = document.getElementById(this.wrapperId)
                    if (!this.triggerElement || !datepickerWrapper) {
                        return
                    }
                    const rightPosition =
                        this.triggerElement.getBoundingClientRect().left +
                        datepickerWrapper.getBoundingClientRect().width
                    this.alignRight = rightPosition > viewportWidth
                })
            }
        }
    }
</script>

<style lang="sass" src="./rsl-date-picker.sass"></style>
